import { type RouteRecordRaw } from 'vue-router'

import { useNewsArticleStore } from './newsArticle.store'

export const NewsArticleRouter: RouteRecordRaw[] = [
  {
    path: '/newsArticles',
    component: async () => import('./NewsArticles.vue'),
    async beforeEnter() {
      await useNewsArticleStore.getState().list()
    },
  },
]
